import React, { useState } from 'react';

const WhatsAppInfo: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '90px',
        right: '20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '15px 20px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        maxWidth: '280px',
        zIndex: 999,
        border: '1px solid #E9ECEF',
        animation: 'slideInRight 0.3s ease-out'
      }}
    >
      <button
        onClick={() => setIsVisible(false)}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'none',
          border: 'none',
          fontSize: '18px',
          cursor: 'pointer',
          color: '#6C757D',
          padding: '2px'
        }}
      >
        ×
      </button>
      
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            backgroundColor: '#25D366',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px'
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        </div>
        <div>
          <h4 style={{ margin: 0, color: 'var(--ozarks-blue-dark)', fontSize: '14px', fontWeight: 600 }}>
            Ozarkselec
          </h4>
          <p style={{ margin: 0, color: 'var(--ozarks-gray)', fontSize: '11px' }}>
            En ligne maintenant
          </p>
        </div>
      </div>
      
      <p style={{ 
        margin: '0 0 12px 0', 
        color: 'var(--ozarks-dark)', 
        fontSize: '13px', 
        lineHeight: '1.4' 
      }}>
        💬 <strong>Réponse rapide garantie !</strong><br />
        Nous répondons généralement sous 2h en journée.
      </p>
      
      <div style={{
        padding: '8px 10px',
        backgroundColor: 'var(--ozarks-light-gray)',
        borderRadius: '8px',
        fontSize: '11px',
        color: 'var(--ozarks-gray)',
        textAlign: 'center'
      }}>
        🕐 Lun-Ven: 8h00-19h00
      </div>

      <style>{`
        @keyframes slideInRight {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsAppInfo;